import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
// Type-only import (erased at compile time, so no runtime api→mocks coupling).
// The prototype never declared a formal patient-profile interface; the fixture
// shape is the source of truth for this demo data.
import type { CareOsPatientProfile } from '../../mocks/fixtures/careOSPrototype';

/**
 * Fetches a careOS prototype patient profile from the mock layer
 * (GET /private/careos/patient/:id). Mirrors the provider-home hooks'
 * auth-gated react-query shape.
 */
export const useCareOsPatient = (patientId: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<CareOsPatientProfile, Error>({
    queryKey: ['careos-patient', patientId, userToken],
    queryFn: () =>
      api({ route: `/private/careos/patient/${patientId}`, token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken && !!patientId,
    refetchOnWindowFocus: false,
  });

  return { patient: data, isLoading, isError };
};
